module.exports = __webpack_public_path__ + "img/TJ.42cb52b7.png";